function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, "Remove from My Collection");

var _ref2 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "heart-fill",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M13.9887423,4.53297626 C14.3977202,4.04601685 14.906226,3.52584164 15.5124211,3.02415181 C17.4614963,1.41108831 19.733302,0.641961866 22.2538577,1.15440986 C27.9769233,2.3179523 29.7604441,9.56991751 26.0794274,15.1216679 C25.451919,16.068083 24.6440163,17.0953865 23.6767302,18.1939869 C22.8831883,19.0952562 21.9909588,20.0346925 21.0174648,21.0019041 C19.6192393,22.3911061 18.1237318,23.7694433 16.6284688,25.0758874 C16.1052348,25.5330485 15.6191664,25.9487766 15.182538,26.3153203 C14.9194712,26.5361613 14.7305305,26.692187 14.6280132,26.7756166 L14.0017603,27.2852673 L13.3715992,26.7804568 C13.2690707,26.6983231 13.0802371,26.5447442 12.8173775,26.3272884 C12.3811664,25.966424 11.8955816,25.5568888 11.3728783,25.1062205 C9.87913804,23.8183362 8.3851502,22.4572053 6.98827677,21.0821242 C5.96677306,20.0765567 5.03515269,19.0999624 4.21335698,18.1638521 C3.29007697,17.1121407 2.51702134,16.1247804 1.91306939,15.2098629 C-1.75507485,9.65304745 0.0214887438,2.406867 5.73976011,1.24429927 C8.25483253,0.73296606 10.5235498,1.48130459 12.4719061,3.06155219 C13.0742429,3.55008777 13.5804625,4.0571378 13.9887423,4.53297626 Z",
  id: "Path",
  fill: "#3B3A42",
  fillRule: "nonzero"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    version: 1.1
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/heart-fill.076467ff.svg";
export { SvgComponent as ReactComponent };